import React from 'react';
import {
  neuroConsentV2InsuranceFieldsBase,
  GOVERNMENT_INSURANCES,
  IN_NETWORK_INSURANCES,
  RELATIONSHIP_OPTIONS,
  OTHER_OPTION,
  BillingType,
} from '@tempus/patient-forms-service-shared';
import { InsuranceType } from 'requisition-service-shared';
import typography from '@tcl-boron-styles/typography/dist/index.module.css';
import FormTable, { FormTableField, FormTableFieldFrontend } from '../../../shared/FormTable';
import { REQUIRED_FIELD_WARNING } from '../../../shared/validation-utils';
import { combineFormConfigs } from '../../../shared/utils';
import standaloneStyles from '../../../shared/standalone-styles.module.css';

const InsuranceInformationSubform: React.FC<{ insuranceType: InsuranceType }> = ({ insuranceType }) => {
  const standardConditionalValueConfig = {
    fieldNameToCheck: 'insuranceCompanyName',
    valueToCheck: OTHER_OPTION.value,
    conditionalLogic: (value: any, conditionalValue: string) => {
      return !(value === conditionalValue || value === '');
    },
  };
  const insuranceInformationFieldsFrontend: FormTableFieldFrontend[] = [
    {
      name: 'insuranceCompanyName',
      props: {
        placeholder: 'Select Insurance Plan Type',
        dropdownOptions: (insuranceType === InsuranceType.Private ? IN_NETWORK_INSURANCES : GOVERNMENT_INSURANCES)
          .map((insurance) => ({
            label: insurance,
            value: insurance,
          }))
          .concat(insuranceType === InsuranceType.Private ? OTHER_OPTION : []),
      },
      validate: (value: any | undefined) => {
        if (!value) return REQUIRED_FIELD_WARNING;
      },
    },
    {
      name: 'insuranceProviderName',
      validate: (value: any | undefined) => {
        const CHARACTER_LIMIT = 40;
        if (!value) return REQUIRED_FIELD_WARNING;
        if (value.length > CHARACTER_LIMIT)
          return `Insurance Provider Name must be less than ${CHARACTER_LIMIT} characters`;
      },
      conditionalValueConfig: {
        ...standardConditionalValueConfig,
        additionalConditions: [
          {
            fieldNameToCheck: 'billingType',
            valueToCheck: BillingType.PUBLIC_INSURANCE,
            conditionalLogic: (value: any, conditionalValue: string) => {
              return value === conditionalValue;
            },
          },
        ],
      },
    },
    {
      name: 'policyNumber',
      validate: (value: any | undefined) => {
        if (!value) return REQUIRED_FIELD_WARNING;
      },
      conditionalValueConfig: standardConditionalValueConfig,
    },
    {
      name: 'groupNumber',
      conditionalValueConfig: standardConditionalValueConfig,
    },
    {
      name: 'policyHolderName',
      validate: (value: any | undefined) => {
        if (!value) return REQUIRED_FIELD_WARNING;
      },
      conditionalValueConfig: standardConditionalValueConfig,
    },
    {
      name: 'relationshipToPolicyHolder',
      props: {
        placeholder: 'Select Relationship to Policy Holder',
        dropdownOptions: RELATIONSHIP_OPTIONS,
      },
      validate: (value: any | undefined) => {
        if (!value) return REQUIRED_FIELD_WARNING;
      },
      conditionalValueConfig: standardConditionalValueConfig,
    },
  ];

  const neuroConsentV2InsuranceFields: FormTableField[] = combineFormConfigs(
    insuranceInformationFieldsFrontend,
    neuroConsentV2InsuranceFieldsBase,
  );

  return (
    <div className={standaloneStyles.formInputContainer}>
      <div className={typography.subSectionHeader}>Insurance Information</div>
      <FormTable fields={neuroConsentV2InsuranceFields} />
    </div>
  );
};

export default InsuranceInformationSubform;
